myApp.controller('dashboardController', ['$scope', 'timeEntry', '$parse',
    function($scope, timeEntry, $parse) {
        timeEntry.getTimeSheetEntryByClient().success(function(response) {
            $scope.timeEntryClientOverview = response;
        });

        timeEntry.getTimeSheetEntryByDate().success(function(response) {
            $scope.timeEntryOverview = response;
        });

        timeEntry.getTimeSheetEntryByUser().success(function(response) {
            $scope.timeEntryUserOverview = response;
        });

        timeEntry.getTimeSheetEntryByTag().success(function(response) {
            $scope.timeEntryTagOverview = response;
        });

        angular.extend($scope, {
            graphLabels: {}
        });

        angular.extend($scope, {
            changeTag: function(url) {
                $scope.tabUrl = url;
            }
        });

        $scope.labels = ["Download Sales", "In-Store Sales", "Mail-Order Sales"];
        $scope.data = [300, 500, 100];
    }
]);

// myApp.controller('dashboardController', ['$scope', 'timeEntry', '$parse',
//     function($scope, timeEntry, $parse) {
//
//         timeEntry.getTimeSheetEntryByUser().success(function(response) {
//             $scope.timeEntryUserOverview = response;
//         });
//
//         angular.extend($scope, {
//             graphLabels: {}
//         });
//
//         angular.extend($scope, {
//             changeTag: function(url) {
//                 $scope.tabUrl = url;
//             }
//         });
//
//         $scope.labels = ["Download Sales", "In-Store Sales", "Mail-Order Sales"];
//         $scope.data = [300, 500, 100];
//     }
// ]);
